import React from 'react';
import {Button, SecSubTitle, SecTitle} from '../../components';
import {Link} from "react-router-dom";


const CtaOneEInvoice = ({data,className}) => {


    return (
        <div className={`z-index-common space-top space-extra-bottom background-image ${className || ''}`}
          style={{backgroundImage: `url('${data?.image ?? "images/bg/bg-read.png"}')`}}>
        <div className="container">
            <div className="text-center text-lg-start align-items-center justify-content-between">
                <div  style={{flex: 1}} className="col-lg-auto">
                    <SecSubTitle className="">{data?.subTitle}</SecSubTitle>
                    <SecTitle className="cta-title1 h1">{data?.title}</SecTitle>
                </div>
                <div  className="col-lg-auto mt-5">
                    <div className={'row align-items-center  '}>
                        {
                            data?.buttons?.map((button, index) => {
                                return (
                                    <div className="col-lg-auto">
                                        <Button
                                            className={index === 1 ? "style2" : ""}
                                            path={button?.path}>{button?.title}</Button>
                                    </div>
                                )
                            })
                        }
                    </div>
                    </div>

                </div>
            </div>
        </div>
            )
            };

            export default CtaOneEInvoice;